import React from "react";
import { FooterContainer, FooterWrapper, SocialMedia, SocialMediaWrap, Signed, SocialIcons, SocialIconsLinks, } from "./footerStyled";
import {FaLinkedin, FaInstagram} from 'react-icons/fa'

const Footer = () => {
    return(
        <FooterContainer>
            <FooterWrapper>
                <SocialMedia>
                    <SocialMediaWrap>
                        <Signed>Desenvolvido por João Vítor Tito © {new Date().getFullYear()} </Signed>
                        <SocialIcons>
                            <SocialIconsLinks href='https://www.linkedin.com/in/joaovitormiotti/' target="_blank" arial-label="LinkedIn">
                                <FaLinkedin/>
                            </SocialIconsLinks>
                            <SocialIconsLinks href='https://www.instagram.com/oi_sou_o_tito/' target="_blank" arial-label="Instragam">
                                <FaInstagram />
                            </SocialIconsLinks>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrapper>
        </FooterContainer>
    )

}

export default Footer;